import { Button, ButtonGroup } from 'Components/Core';
import { PageSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/Ags/Export';
import { useDispatch, useSelector } from 'react-redux';

const AgsExportSection: React.FC = () => {
  const dispatch = useDispatch();
  const busyState = useSelector((state) => state.agsExport.status.busy);
  const agsExportId = useSelector((state) => state.agsExport.agsExportId);

  if (!agsExportId) {
    return null;
  }
  return (
    <PageSection heading="AGS Export">
      <ButtonGroup>
        <Button onClick={() => dispatch(actions.reissueExport(agsExportId))} loading={busyState}>
          Reissue
        </Button>
      </ButtonGroup>
    </PageSection>
  );
};

export { AgsExportSection };
export default AgsExportSection;
